var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretNext = function SvgCaretNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 10.5 18.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 10.2c.5-.7.2-1.4-.3-2L2.4.4C1-.8-.8.9.4 2.4c.3.4 6.8 6.8 6.8 7 0 .3-6.3 6.6-6.7 7-1.2 1.2.7 3 1.9 1.9a148 148 0 0 0 7.9-8.1"
  })));
};
export default SvgCaretNext;